type WelcomeMessagesProps = {
    newMailsCount: number;
    importantMailsCount: number;
    savedCO2Kg: number;
};

export default class WelcomeMessages {
    newMailsCount: number;

    importantMailsCount: number;

    savedCO2Kg: number;

    constructor({
        newMailsCount,
        importantMailsCount,
        savedCO2Kg,
    }: WelcomeMessagesProps) {
        this.newMailsCount = newMailsCount;
        this.importantMailsCount = importantMailsCount;
        this.savedCO2Kg = savedCO2Kg;
    }
}
